import React, { useState, useEffect, useRef } from 'react';
import { mockApiData, initialTerms, emptyParty, fakeApiCall } from '../data/mockData';
import ItemModal from '../ItemModal';
import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';
import Page4 from './Page4';
import Page5 from './Page5';

const BillingModule = ({
    initialData,
    onBackToList,
    selectedTxnTypeId,
    setSelectedTxnTypeId,
    loadingTxnTypes,
    errorTxnTypes
}) => {
    const [page, setPage] = useState(1);
    const [txnTypes, setTxnTypes] = useState([]);
    const [subTypes, setSubTypes] = useState([]);
    const [selectedSubTypeId, setSelectedSubTypeId] = useState('');
    const [docLabel, setDocLabel] = useState('Doc No');
    const [dateLabel, setDateLabel] = useState('Doc Date');
    const [docNumber, setDocNumber] = useState('');
    const [docDate, setDocDate] = useState(new Date().toISOString().split('T')[0]);
    const [addlRefNo, setAddlRefNo] = useState('');
    const [refDate, setRefDate] = useState(new Date().toISOString().split('T')[0]);
    const [remarks, setRemarks] = useState('');
    const [billItems, setBillItems] = useState([]);
    const [products, setProducts] = useState([]);
    const [itemSearchTerm, setItemSearchTerm] = useState('');
    const [parties, setParties] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedParty, setSelectedParty] = useState(null);
    const [showPartyList, setShowPartyList] = useState(false);
    const [isEditingParty, setIsEditingParty] = useState(false);
    const [useDeliveryPoint, setUseDeliveryPoint] = useState(false);
    const [deliveryPointSearchTerm, setDeliveryPointSearchTerm] = useState('');
    const [selectedDeliveryPoint, setSelectedDeliveryPoint] = useState(null);
    const [showDeliveryPointList, setShowDeliveryPointList] = useState(false);
    const [isEditingDeliveryPoint, setIsEditingDeliveryPoint] = useState(false);
    const [despatchThroughOptions, setDespatchThroughOptions] = useState([]);
    const [selectedDespatchThrough, setSelectedDespatchThrough] = useState('');
    const [vehicleTypeOptions, setVehicleTypeOptions] = useState([]);
    const [selectedVehicleType, setSelectedVehicleType] = useState('');
    const [vehicleNo, setVehicleNo] = useState('');
    const [isItemModalOpen, setIsItemModalOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [editingItemIndex, setEditingItemIndex] = useState(null);
    const printRef = useRef();
    const [partyData, setPartyData] = useState(null);
    const [isPartySectionOpen, setIsPartySectionOpen] = useState(true);
    const [isCreating, setIsCreating] = useState(false);
    const [terms, setTerms] = useState(initialTerms);
    const [ewayBillNo, setEwayBillNo] = useState('');
    const [despatchRef, setDespatchRef] = useState('');
    const [deliveryPointData, setDeliveryPointData] = useState(null);
    const [isDeliverySectionOpen, setIsDeliverySectionOpen] = useState(false);
    const [isTransportSectionOpen, setIsTransportSectionOpen] = useState(false);
    const [isPage2NextDisabled, setIsPage2NextDisabled] = useState(false);
    const [itemSelectionMode, setItemSelectionMode] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [orders, setOrders] = useState([]);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [documents, setDocuments] = useState([]); 
    const [GlId, setGlId] = useState(null);
    const [user, setUser] = useState("admin");

    useEffect(() => {
        if (initialData) {
            setDocNumber(initialData.docNumber);
            setDocDate(initialData.docDate);
        }
        fakeApiCall(mockApiData.transactionTypes).then(data => setTxnTypes(data));
        fakeApiCall(mockApiData.parties).then(data => setParties(data));
        fakeApiCall(mockApiData.products).then(data => setProducts(data));
        fakeApiCall(mockApiData.despatchThrough).then(data => setDespatchThroughOptions(data));
        fakeApiCall(mockApiData.vehicleTypes).then(data => setVehicleTypeOptions(data));
    }, [initialData]);

    useEffect(() => {
        if (selectedTxnTypeId) {
            const filteredSubTypes = mockApiData.transactionSubTypes.filter(st => st.typeId === parseInt(selectedTxnTypeId));
            setSubTypes(filteredSubTypes);
            setSelectedSubTypeId('');
        } else setSubTypes([]);
    }, [selectedTxnTypeId]);

    useEffect(() => {
        if (selectedSubTypeId) {
            const subType = subTypes.find(st => st.id === parseInt(selectedSubTypeId));
            setDocLabel(subType ? subType.docLabel : 'Doc No');
            setDateLabel(subType ? subType.dateLabel : 'Doc Date');
        }
    }, [selectedSubTypeId, subTypes]);


    const handlePartySearch = (e) => {
        setSearchTerm(e.target.value);
        setShowPartyList(true);
    };

    const handlePage1Next = (newGlId) => {
        setGlId(newGlId); // save GlId
        setPage(2);        // go to Page2
    };

    const handleSelectParty = (party) => {
        setSelectedParty(party);
        setPartyData({ ...party });
        setSearchTerm(party.PName);
        setShowPartyList(false);
        setIsPartySectionOpen(false);
    };

    const handleAddNewParty = () => {
        setShowPartyList(false);
        setSelectedParty(null);
        setPartyData(emptyParty);
        setIsCreating(true);
        setIsEditingParty(true);
        setSearchTerm('');
    };


    const handlePartyInputChange = (e) => {
        const { name, value } = e.target;
        setPartyData(prev => ({ ...prev, [name]: value }));
    };

    const handleSaveParty = () => {
        if (isCreating) {
            const newPartyWithId = { ...partyData, PId: Date.now() };
            setParties(prev => [...prev, newPartyWithId]);
            setSelectedParty(newPartyWithId);
            setPartyData(newPartyWithId);
        } else {
            setParties(parties.map(p => p.PId === partyData.PId ? partyData : p));
            setSelectedParty(partyData);
        }
        setIsEditingParty(false);
        setIsCreating(false);
    };

    const handleCancelEditParty = () => {
        setPartyData(selectedParty);
        setIsEditingParty(false);
        setIsCreating(false);
    };

    const handleUseDeliveryPointChange = (e) => {
        const isChecked = e.target.checked;
        setUseDeliveryPoint(isChecked);
        setIsDeliverySectionOpen(isChecked);
        if (!isChecked) {
            setSelectedDeliveryPoint(null);
            setDeliveryPointData(null);
            setDeliveryPointSearchTerm('');
            setIsEditingDeliveryPoint(false);
        }
    };

    const handleDeliveryPointSearch = (e) => {
        setDeliveryPointSearchTerm(e.target.value);
        setShowDeliveryPointList(true);
    };

    const handleSelectDeliveryPoint = (point) => {
        setSelectedDeliveryPoint(point);
        setDeliveryPointData(point);
        setDeliveryPointSearchTerm(point.PName);
        setShowDeliveryPointList(false);
        setIsEditingDeliveryPoint(false);
    };

    const handleDeliveryPointInputChange = (e) => {
        const { name, value } = e.target;
        setDeliveryPointData(prev => ({ ...prev, [name]: value }));
    };

    const handleSaveDeliveryPoint = () => {
        setSelectedDeliveryPoint(deliveryPointData);
        setIsEditingDeliveryPoint(false);
    };

    const handleCancelEditDeliveryPoint = () => {
        setDeliveryPointData(selectedDeliveryPoint);
        setIsEditingDeliveryPoint(false);
    };

    const handleOpenItemModal = (item) => {
        setEditingItemIndex(null);
        setCurrentItem({
            ...item,
            qty: 1,
            discPercent: 0,
        });
        setIsItemModalOpen(true);
        setItemSearchTerm('');
    };

    const handleEditItem = (item, index) => {
        setEditingItemIndex(index);
        setCurrentItem({ ...item });
        setIsItemModalOpen(true);
    };

    const handleSaveItem = (item) => {
        if (editingItemIndex !== null) {
            const updatedItems = [...billItems];
            updatedItems[editingItemIndex] = item;
            setBillItems(updatedItems);
        } else {
            setBillItems([...billItems, item]);
        }
        setIsItemModalOpen(false);
        setCurrentItem(null);
        setEditingItemIndex(null);
    };

    const handleRemoveBillItem = (index) => {
        setBillItems(billItems.filter((_, i) => i !== index));
    };

    const handleTermChange = (key, field, value) => {
        setTerms(prev => ({ ...prev, [key]: { ...prev[key], [field]: value } }));
    };

    const handleAddItemsFromSource = (sourceItems) => {
        if (!sourceItems) return;
        const newItems = sourceItems.map(item => {
            const listAmount = (item.qty || 1) * (item.rate || 0);
            const taxAmount = listAmount * ((item.taxPercent || 0) / 100);
            return {
                ...item,
                qty: item.qty || 1,
                discPercent: 0,
                discAmount: 0,
                listAmount,
                taxAmount,
                netAmount: listAmount + taxAmount
            };
        });
        setBillItems([...billItems, ...newItems]);
    };

    const handleFinalSubmit = (mode) => {
        alert(`Transaction ${docNumber} saved in ${mode} mode.`);
        onBackToList();
    };

    const handlePrint = () => {
        window.print();
    };

    const filteredParties = parties.filter(p => p.PName.toLowerCase().includes(searchTerm.toLowerCase()));
    const filteredProducts = products.filter(p => p.desc.toLowerCase().includes(itemSearchTerm.toLowerCase()));
    const filteredDeliveryPoints = parties.filter(p => p.PName.toLowerCase().includes(deliveryPointSearchTerm.toLowerCase()));

    const isPage1NextDisabled = !selectedTxnTypeId || !selectedSubTypeId;

    const isPage3NextDisabled = billItems.length === 0;

    useEffect(() => {
        setIsPage2NextDisabled(!selectedParty || isEditingParty || (useDeliveryPoint && isEditingDeliveryPoint));
    }, [selectedParty, isEditingParty, useDeliveryPoint, isEditingDeliveryPoint]);

    const renderPage = () => {

        switch (page) {
            case 1:
                return <Page1
                    setPage={setPage}
                    onGlIdReady={handlePage1Next}
                    setGlId={setGlId}
                    user={user}
                    txnTypes={txnTypes}
                    subTypes={subTypes}
                    loadingTxnTypes={loadingTxnTypes}
                    errorTxnTypes={errorTxnTypes}
                    selectedTxnTypeId={selectedTxnTypeId}
                    setSelectedTxnTypeId={setSelectedTxnTypeId}
                    selectedSubTypeId={selectedSubTypeId}
                    setSelectedSubTypeId={setSelectedSubTypeId}
                    docLabel={docLabel}
                    dateLabel={dateLabel}
                    docNumber={docNumber}
                    setDocNumber={setDocNumber}
                    docDate={docDate}
                    setDocDate={setDocDate}
                    addlRefNo={addlRefNo}
                    setAddlRefNo={setAddlRefNo}
                    refDate={refDate}
                    setRefDate={setRefDate}
                    remarks={remarks}
                    setRemarks={setRemarks}
                    onBackToList={onBackToList}
                    isPage1NextDisabled={isPage1NextDisabled}
                    handleFinalSubmit={handleFinalSubmit}
                    showPartyList={showPartyList}
                    setShowPartyList={setShowPartyList}
                    deliveryPointSearchTerm={deliveryPointSearchTerm}
                    setDeliveryPointSearchTerm={setDeliveryPointSearchTerm}
                    showDeliveryPointList={showDeliveryPointList}
                    setShowDeliveryPointList={setShowDeliveryPointList}
                    isEditingDeliveryPoint={isEditingDeliveryPoint}
                    setIsEditingDeliveryPoint={setIsEditingDeliveryPoint}
                    isTransportSectionOpen={isTransportSectionOpen}
                    setIsTransportSectionOpen={setIsTransportSectionOpen}
                    isPage2NextDisabled={isPage2NextDisabled}
                />;
            case 2:
                return <Page2
                    GlId={GlId}
                    user={user}
                    deliveryPointSearchTerm={deliveryPointSearchTerm}
                    setDeliveryPointSearchTerm={setDeliveryPointSearchTerm}
                    setSearchTerm={setSearchTerm}
                    isDeliverySectionOpen={isDeliverySectionOpen}
                    setIsDeliverySectionOpen={setIsDeliverySectionOpen}
                    setIsEditingParty={setIsEditingParty}
                    isPartySectionOpen={isPartySectionOpen}
                    setIsPartySectionOpen={setIsPartySectionOpen}
                    selectedParty={selectedParty}
                    setSelectedParty={setSelectedParty}
                    searchTerm={searchTerm}
                    handlePartySearch={handlePartySearch}
                    showPartyList={showPartyList}
                    setShowPartyList={setShowPartyList}
                    filteredParties={filteredParties}
                    handleSelectParty={handleSelectParty}
                    handleAddNewParty={handleAddNewParty}
                    partyData={partyData}
                    isEditingParty={isEditingParty}
                    isCreating={isCreating}
                    handlePartyInputChange={handlePartyInputChange}
                    handleSaveParty={handleSaveParty}
                    handleCancelEditParty={handleCancelEditParty}
                    useDeliveryPoint={useDeliveryPoint}
                    handleUseDeliveryPointChange={handleUseDeliveryPointChange}
                    handleDeliveryPointSearch={handleDeliveryPointSearch}
                    showDeliveryPointList={showDeliveryPointList}
                    setShowDeliveryPointList={setShowDeliveryPointList}
                    filteredDeliveryPoints={filteredDeliveryPoints}
                    selectedDeliveryPoint={selectedDeliveryPoint}
                    handleSelectDeliveryPoint={handleSelectDeliveryPoint}
                    deliveryPointData={deliveryPointData}
                    isEditingDeliveryPoint={isEditingDeliveryPoint}
                    setIsEditingDeliveryPoint={setIsEditingDeliveryPoint}
                    handleDeliveryPointInputChange={handleDeliveryPointInputChange}
                    handleSaveDeliveryPoint={handleSaveDeliveryPoint}
                    handleCancelEditDeliveryPoint={handleCancelEditDeliveryPoint}
                    selectedDespatchThrough={selectedDespatchThrough}
                    setSelectedDespatchThrough={setSelectedDespatchThrough}
                    vehicleNo={vehicleNo}
                    setVehicleNo={setVehicleNo}
                    selectedVehicleType={selectedVehicleType}
                    setSelectedVehicleType={setSelectedVehicleType}
                    vehicleTypeOptions={vehicleTypeOptions}
                    despatchThroughOptions={despatchThroughOptions}
                    ewayBillNo={ewayBillNo}
                    setEwayBillNo={setEwayBillNo}
                    despatchRef={despatchRef}
                    setDespatchRef={setDespatchRef}
                    isTransportSectionOpen={isTransportSectionOpen}
                    setIsTransportSectionOpen={setIsTransportSectionOpen}
                    setPage={setPage}
                    isPage2NextDisabled={isPage2NextDisabled}
                />;
            case 3:
                return <Page3
                    billItems={billItems}
                    setBillItems={setBillItems}
                    itemSelectionMode={itemSelectionMode}
                    setItemSelectionMode={setItemSelectionMode}
                    itemSearchTerm={itemSearchTerm}
                    setItemSearchTerm={setItemSearchTerm}
                    filteredProducts={filteredProducts}
                    handleOpenItemModal={handleOpenItemModal}
                    selectedOrderId={selectedOrderId}
                    setSelectedOrderId={setSelectedOrderId}
                    orders={orders}
                    selectedDocId={selectedDocId}
                    setSelectedDocId={setSelectedDocId}
                    documents={documents}
                    handleAddItemsFromSource={handleAddItemsFromSource}
                    handleEditItem={handleEditItem}
                    handleRemoveBillItem={handleRemoveBillItem}
                    netTotal={billItems.reduce((t, i) => t + (i.netAmount || 0), 0)}
                    setPage={setPage}
                    isPage3NextDisabled={isPage3NextDisabled}
                />;
            case 4:
                return <Page4
                    useDeliveryPoint={useDeliveryPoint}
                    handleUseDeliveryPointChange={() => setUseDeliveryPoint(!useDeliveryPoint)}
                    deliveryPointSearchTerm={deliveryPointSearchTerm}
                    handleDeliveryPointSearch={(e) => setDeliveryPointSearchTerm(e.target.value)}
                    showDeliveryPointList={showDeliveryPointList}
                    filteredDeliveryPoints={filteredDeliveryPoints}
                    handleSelectDeliveryPoint={(dp) => setSelectedDeliveryPoint(dp)}
                    selectedDespatchThrough={selectedDespatchThrough}
                    setSelectedDespatchThrough={setSelectedDespatchThrough}
                    despatchThroughOptions={despatchThroughOptions}
                    selectedVehicleType={selectedVehicleType}
                    setSelectedVehicleType={setSelectedVehicleType}
                    vehicleTypeOptions={vehicleTypeOptions}
                    vehicleNo={vehicleNo}
                    setVehicleNo={setVehicleNo}
                    setPage={setPage}
                />;
            case 5:
                return <Page5
                    billItems={billItems}
                    subTotal={billItems.reduce((t, i) => t + (i.listAmount || 0), 0)}
                    taxTotal={billItems.reduce((t, i) => t + (i.taxAmount || 0), 0)}
                    netTotal={billItems.reduce((t, i) => t + (i.netAmount || 0), 0)}
                    handleFinalSubmit={handleFinalSubmit}
                    setPage={setPage}
                />;
            default:
                return null;
        }
    };

    return (
        <div className="p-4 bg-white shadow rounded-md">
            {renderPage()}

            {isItemModalOpen && (
                <ItemModal
                    item={currentItem}
                    onSave={handleSaveItem}
                    onCancel={() => setIsItemModalOpen(false)}
                />
            )}
        </div>
    );
};

export default BillingModule;
